module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"CMS":"Webauftritt","Targetpage":"Zielseite","select ...":"auswählen ..."}}')
  delete Component.options._Ctor
}
